import { logger } from "../../../app/utils/utils";
import configureStore from "../../../store/configureStore";

export default function dbAddRecord(data, idToken) {
  const state = configureStore.getState();
  let fbDbUrl = state.db.team.fbDbUrl;
  let fbCloudUrl = state.db.team.fbCloudUrl;
  return dispatch => {
    let fetchQuery = fbDbUrl + "/" + data.path + ".json";
    fetchQuery = fetchQuery + "?auth=" + idToken;

    //logger("DEBUG","dbAddRecord(data)", "Adding record to DB: "+fetchQuery+" | "+JSON.stringify(data.payload));
    return fetch(fetchQuery, {
      method: "POST",
      body: JSON.stringify(data.payload)
    })
      .then(res => res.json())
      .then(parsedRes => {
        //logger("DEBUG","dbAddRecord(data)", "Upload to firebase successful " + parsedRes.name);
        return parsedRes.name;
      })
      .catch(err => {
        logger(
          "BASIC",
          "dbAddRecord(data)",
          "Add project unsuccessful -> " + err
        );
        alert(
          "We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord" +
            data.path +
            "][" +
            err +
            "]"
        );
        //console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/dbAddRecord.js